module.exports = __webpack_public_path__ + "static/media/time.003b7a3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/time.svg
// module id = 272
// module chunks = 0